import { createFileRoute } from '@tanstack/react-router'

import { AdminDashboardPage } from '@/pages/admin/dashboard/admin-dashboard-page'

export const Route = createFileRoute('/_private/admin/dashboard')({
  component: AdminDashboardPage,
})
